import { AuthSignInRequest } from "entities/auth";
import * as Yup from "yup";

import { EMAIL_REGEX } from "utils/constants";

export const validationSchema = Yup.object<AuthSignInRequest>({
  email: Yup.string().required("Email is required").matches(EMAIL_REGEX, "Invalid email address"),
  password: Yup.string().required("Password is required"),
  remember: Yup.boolean(),
});
